<div class="tw-min-w-[200px] xl:tw-min-w-[260px] tw-h-full">
  <mh-nps-widget
    [loading]="loading"
    [value]="npsValue"
    [promoters]="npsPromoters"
    [passives]="npsPassives"
    [detractors]="npsDetractors"
    [status]="npsStatus | translate"
    [hideViewMoreButton]="true"
    (onDownloadEbook)="onDownloadEbook()">
  </mh-nps-widget>
</div>
